/** @jsxImportSource @emotion/react */
'use memo'

import React, { useState } from 'react'
import { useHomeHighlights } from './hooks/useHomeHighlights'
import { PlayerHighlight } from '../../../Player/types'
import HighlightWidgetHeader from './HighlightWidgetHeader'
import HighlightCardItem from './HighlightCardItem'
import HighlightVideoModal from './HighlightVideoModal'
import {
  containerStyle,
  headerSectionStyle,
  headerDividerStyle,
  cardRowStyle,
} from './styles'

const HighlightWidget: React.FC = () => {
  const { latestSix, isVisible } = useHomeHighlights()
  const [selected, setSelected] = useState<PlayerHighlight | null>(null)

  if (!isVisible || latestSix.length === 0) {
    return null
  }

  return (
    <div css={containerStyle}>
      <div css={headerSectionStyle}>
        <HighlightWidgetHeader />
        <div css={headerDividerStyle} />
      </div>
      <div css={cardRowStyle}>
        {(() => {
          return latestSix.map((highlight, index) => (
            <HighlightCardItem
              key={`${highlight.id}-${index}`}
              highlight={highlight}
              isActive={selected?.id === highlight.id}
              itemCount={latestSix.length}
              onClick={setSelected}
            />
          ))
        })()}
      </div>
      <HighlightVideoModal
        highlight={selected}
        onClose={() => setSelected(null)}
      />
    </div>
  )
}

export default HighlightWidget
